import { HelicoptersScene } from './game/HelicoptersScene';
import { HelicoptersMenuScene } from './menu/HelicoptersMenuScene';
import { SplashScene } from './splash/SplashScene';


export const scenes = {
    Splash: SplashScene,
    Menu: HelicoptersMenuScene,
    Helicopters: HelicoptersScene,
} as const;
